import { useInfiniteQuery } from 'react-query';

import getProducts from '@/common/api/products/getProducts';

const useProducts = (queryKey, params, disabled, keepPreviousData = true) =>
  useInfiniteQuery(queryKey, (cacheKey) => getProducts(cacheKey, params), {
    enabled: !disabled,
    getPreviousPageParam: (firstPage) => {
      const currentPage = firstPage.products.meta.current_page;

      return currentPage > 1 ? currentPage - 1 : false;
    },
    getNextPageParam: (lastPage) => {
      const currentPage = lastPage.products.meta.current_page;
      const totalPages = lastPage.products.meta.total_pages;

      return currentPage < totalPages ? currentPage + 1 : false;
    },
    keepPreviousData,
  });

export default useProducts;
